import { ApprovalDelegate } from '@/interfaces/approvals/approvals';
import { Person, FilterList } from '@/interfaces/person';
import { PersonService } from '@/services/person/person.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { switchMap } from 'rxjs/operators';
import { ApprovalsService } from '../../../../../../services/approvals/approvals.service';
import { DelegateService } from '../../../../../../services/delegate/delegate.service';

@Component({
  selector: 'app-delegate',
  templateUrl: './delegate.component.html',
  styleUrls: ['./delegate.component.css', '../../approve.component.css'],
})
export class DelegateComponent implements OnInit {
  @Output() goBack = new EventEmitter();
  @Input() controlForm = new FormGroup({
    id: new FormControl(null),
    note: new FormControl(null),
  });
  @Input() requirementId?: number;

  get noteFormControl(): FormControl {
    return this.controlForm.controls.note as FormControl;
  }
  get idFormControl(): FormControl {
    return this.controlForm.controls.id as FormControl;
  }

  privateForm = new FormGroup({
    filterText: new FormControl(''),
  });

  boxColor: BoxColors = BoxColors.BROWN_GREY;

  selectedPersonData?: Person;
  listPersonOptions: FilterList = [];
  loadingPersonOptions: boolean = false;

  userData?: State;

  constructor(
    private personService: PersonService,
    private store: Store<StoreState>,
    private route: ActivatedRoute,
    private router: Router,
    private serviceApprovals: ApprovalsService,
    private delegateService: DelegateService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });

  }

  ngOnInit(): void {
    this.privateForm.controls.filterText.valueChanges
      .pipe(
        // throttleTime(600, asyncScheduler, { leading: true, trailing: true }),
        switchMap((value) => {
          this.loadingPersonOptions = true;
          return this.personService.getFilteredList(value);
        }),
      )
      .subscribe({
        next: (options) => {
          this.listPersonOptions = options;
          this.loadingPersonOptions = false;
        },
      });
  }

  onSearchPersonTextChange(text: string) {
    this.privateForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.controlForm.patchValue({ id: +id });
  }

  onSelectPerson() {
    const personId = this.controlForm.controls.id.value;
    this.personService.getPersonDataById(personId).subscribe({
      next: (personData) => {
        this.selectedPersonData = personData;
        this.controlForm.controls.id.patchValue(personId);
      },
    });
  }

  onUnselect() {
    this.selectedPersonData = undefined;
    this.privateForm.patchValue({ filterText: '' });
    this.controlForm.patchValue({ id: null });
  }

  onSubmit() {
    const person = this.selectedPersonData;
    if (person) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres delegar esta aprobación?',
        text: 'La delegación será enviada automáticamente si continúa en Delegar aprobación.',
        text2: 'Presiona volver para regresar a la pantalla anterior.',
        acceptButtonText: 'Delegar aprobación',
        actionOnAccept: () => {
          const formDelegation: ApprovalDelegate = {
            assigned: this.userData?.mdmid as string,
            assignedToDelegate: person.mdmid,
            requirementId: this.requirementId as number,
            email: person.email,
            comment: this.noteFormControl.value,
          };
          this.store.dispatch(loaderAnimationShow());
          this.serviceApprovals.delegateApprovalRequest(formDelegation)
            .subscribe({
              next: () => {
                const ofuscatedData = ofuscate({ email: person.email });
                this.router.navigate(['delegated', ofuscatedData], { relativeTo: this.route });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());
                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigate(['delegated', ofuscatedData], { relativeTo: this.route });

                    }
                  },
                });
              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  onGoBack() {
    this.goBack.emit('');
  }
}
